import { FeatureParams, SubFeatures, GetValues } from "./common";

export type ReviewSubFeatures = {
  zceppa_invite_template: "zceppa_invite_template";
  custom_invite_template: "custom_invite_template";
  review_invite_channel: "review_invite_channel";
  review_reply: "review_reply";
  zceppa_reply_template: "zceppa_reply_template";
  custom_reply_template: "custom_reply_template";
  reply_auto_update_template: "reply_auto_update_template";
  auto_reply: "auto_reply";
  tag_team_member: "tag_team_member";
  performance_report: "performance_report";
  insights: "insights";
  leaderboard: "leaderboard";
  insights_downloadable_report: "insights_downloadable_report";
  review_widget: "review_widget";
  review_feedback_scale: "review_feedback_scale";
  review_gateway: "review_gateway";
  enable_external_reviews: "enable_external_reviews";
  review_auto_ticket: "review_auto_ticket";
  flex_fields: "flex_fields";
};
export const REVIEW_SUBFEATURES: ReviewSubFeatures = {
  zceppa_invite_template: "zceppa_invite_template",
  custom_invite_template: "custom_invite_template",
  review_invite_channel: "review_invite_channel",
  review_reply: "review_reply",
  zceppa_reply_template: "zceppa_reply_template",
  custom_reply_template: "custom_reply_template",
  reply_auto_update_template: "reply_auto_update_template",
  auto_reply: "auto_reply",
  tag_team_member: "tag_team_member",
  performance_report: "performance_report",
  insights: "insights",
  leaderboard: "leaderboard",
  insights_downloadable_report: "insights_downloadable_report",
  review_widget: "review_widget",
  review_feedback_scale: "review_feedback_scale",
  review_gateway: "review_gateway",
  enable_external_reviews: "enable_external_reviews",
  review_auto_ticket: "review_auto_ticket",
  flex_fields: "flex_fields"
};
interface ReviewParams
  extends FeatureParams<"feature_reviews", GetValues<ReviewSubFeatures>> {}
export interface ReviewsFeatures
  extends SubFeatures<GetValues<ReviewSubFeatures>> {}

export interface ReviewStructure {
  [key: string]: ReviewParams;
}
